var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"button is-small pause is-info",on:{"click":function($event){return _vm.pauseStart()}}},[_vm._v("Pause")])])
}
var staticRenderFns = []

export { render, staticRenderFns }